<template>
    <div class="c-selector-filter row">
        <div class="c-selector-filter__wrapper col-md-6 offset-md-3 col-12">
            <div id="tempone" class="c-selector-filter__content">
                <h2 class="h4">{{ title }}</h2>
                <p>{{ description }}</p>
            </div>
            <div class="c-selector-filter__input">
                <fieldset>
                <legend aria-labelledby="tempone" class="sr-only" id="YouthOpportunities">
                Switch for youth opportunities.
                </legend>
                <aha-switch-input :value="enabled"
                :on-text="onText"
                :off-text="offText" 
                :name="name" 
                @change="changed" 
                :isChecked="checked"
                aria-describedby="YouthOpportunities"
                >
                </aha-switch-input>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ["EventBus"],
    data() {
        return {
            url: window.location.href,
            enabled: !!this.checked
        };
    },
    props: {
        title: { type: String },
        description: { type: String },
        name: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        },
        onText: {
            type: String,
            default: 'Yes'
        },
        offText: {
            type: String,
            default: 'No'
        }
    },
    methods: {
        changed({value, name}) {
            this.EventBus.$emit("filterChanged", name, value, this);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-card-selector-filter.vue